// Generated by packages/browser-pyright/build.js. Do not edit.
export const pyrightManifest = {
    version: "1.1.400",
    workerFile: "pyright.v1.1.400.9c80ede5b08c97b323aa.worker.js",
};
